// extracted by mini-css-extract-plugin
export default {"card":"Card_card__52Lrz","empty":"Card_empty__fNUfZ","content":"Card_content__SvTG4"};